import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { DrawingAttachment, DrawingAttachmentKind, DrawingDto } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

export const DrawingActions = createActionGroup({
    source: "Quote Drawing",
    events: {
        // ******** LOAD ******** //
        "Load Drawing": props<{ quoteId: number }>(),
        "Load Drawing Success": props<{ drawing: DrawingDto }>(),
        "Load Drawing Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** UPLOAD ATTACHMENT ******** //
        "Upload Attachment": props<{ tempId: string; quoteId: number; file: File; kind: DrawingAttachmentKind }>(),
        "Upload Attachment Progress": props<{ tempId: string; progress: number }>(),
        "Upload Attachment Success": props<{ tempId: string; attachment: DrawingAttachment; toastKey: string }>(),
        "Upload Attachment Failure": props<{ tempId: string; error: AppError; toastKey: string }>(),

        // ******** DELETE ATTACHMENT ******** //
        "Delete Attachment": props<{ quoteId: number; attachmentId: number }>(),
        "Delete Attachment Success": props<{ attachmentId: number; toastKey: string }>(),
        "Delete Attachment Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** SEND FOR DRAWING ******** //
        // Frontend composes subject + HTML body via ngx-translate; backend relays.
        "Send For Drawing": props<{ quoteId: number; subject: string; message: string }>(),
        "Send For Drawing Success": props<{ drawing: DrawingDto; toastKey: string }>(),
        "Send For Drawing Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** START DRAWING ******** //
        "Start Drawing": props<{ quoteId: number; estimatedCompletion: Date; drawerId?: number; subject: string; message: string }>(),
        "Start Drawing Success": props<{ drawing: DrawingDto; toastKey: string }>(),
        "Start Drawing Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** COMPLETE DRAWING ******** //
        "Complete Drawing": props<{ quoteId: number; sharepointUrl: string; subject: string; message: string }>(),
        "Complete Drawing Success": props<{ drawing: DrawingDto; toastKey: string }>(),
        "Complete Drawing Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** REVOKE DRAWING ******** //
        "Revoke Drawing": props<{ quoteId: number }>(),
        "Revoke Drawing Success": props<{ drawing: DrawingDto; toastKey: string }>(),
        "Revoke Drawing Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** RESET ******** //
        "Reset": emptyProps(),
    },
});
